/* import __COLOCATED_TEMPLATE__ from './custom-checkbox.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface CustomCheckboxArgs {
  value: boolean;
  checkBoxId: string;
  checkBoxType: string;
  labelResourceValue: string;
  disabled?: boolean;
  valueChanged: (newValue: boolean) => void;
}
interface CustomCheckboxSignature {
  Args: CustomCheckboxArgs;
  Element: HTMLDivElement;
}

export default class CustomCheckbox extends Component<CustomCheckboxSignature> {
  get checkBoxType() {
    return this.args.checkBoxType || 'whiteBox';
  }
  @action onChange() {
    if (!this.args.disabled) {
      if (this.args.valueChanged) {
        this.args.valueChanged(!this.args.value);
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    CustomCheckbox: typeof CustomCheckbox;
  }
}
